export default "__VITE_ASSET__CVDwYaRZ__"